import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { FiArrowRight } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import '../../../../assets/css/customer/subscreens/blog/BlogSection.css';
import BlogCard from '../../../../components/customer/blogsinglecard/BlogSingleCard';
import AppContext from "../../../../contexts/AppContext";
import LoadingScreen from '../../../../components/general/animations/Animations.js';

const BlogsSection = () => {
  const navigate = useNavigate();
  const { baseUrl, baseUrlForFiles } = useContext(AppContext);
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  const viewAllblogs = () => {
    axios
      .get(`${baseUrl}/customer/blogs/viewallblogs`)
      .then((response) => {
        console.log(response.data);
        setBlogs(response.data.blogs);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const featuredBlogs = blogs.slice(0, 3);

  useEffect(() => {
    viewAllblogs();
  }, []);

  // if (loading) {
  //   return <LoadingScreen />;
  // }

  return (
    <section className="home-blogs-section">
      <div className="home-blogs-container">
        <div className="home-blogs-header">
          <div>
            <h2>Latest from Our Blog</h2>
            <p>Discover stories, tips, and insights from the world of handmade crafts</p>
          </div>
          <button className="view-all-btn" onClick={() => navigate('/blogs')}>
            View All Blogs
            <FiArrowRight size={18} />
          </button>
        </div>

        <div className="home-blogs-grid">
          {featuredBlogs.map(blog => (
            <BlogCard
              key={blog.id}
              blog={{ ...blog, image: `${baseUrlForFiles}/${blog.blogimage}` }}
              variant="home"
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogsSection;